"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var material_1 = require("@mui/material");
var react_1 = __importDefault(require("react"));
var CheckBox_1 = __importDefault(require("@mui/icons-material/CheckBox"));
var CheckBoxOutlineBlank_1 = __importDefault(require("@mui/icons-material/CheckBoxOutlineBlank"));
var CheckInput = function (props) {
    var theme = (0, material_1.useTheme)();
    return (react_1.default.createElement(material_1.Box, { pt: "18px" }, props.isEditing ?
        (react_1.default.createElement(material_1.FormControlLabel, { label: props.label, className: "primary", name: props.name, disabled: props.disabled, control: react_1.default.createElement(material_1.Checkbox, { color: "primary", checked: props.value, onChange: props.onChange, onBlur: props.onBlur }) }))
        :
            (react_1.default.createElement(material_1.FormControl, null,
                react_1.default.createElement(material_1.Box, { display: "flex", pt: "4px", style: { color: props.disabled ? theme.palette.action.disabled : undefined } },
                    react_1.default.createElement("span", { style: { color: props.disabled ? theme.palette.action.disabled : 'rgba(0,0,0,0.5)' } }, props.value ? react_1.default.createElement(CheckBox_1.default, null) : react_1.default.createElement(CheckBoxOutlineBlank_1.default, null)),
                    " ",
                    react_1.default.createElement(material_1.Box, { ml: 1 },
                        react_1.default.createElement(material_1.Typography, null, props.label)))))));
};
exports.default = CheckInput;
